/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliParentLinkedDto } from '../../models/amoxcalli-parent-linked-dto';

export interface ApiParentStudentsByStudentStudentIdGet$Json$Params {
  studentId: string;
  institutionId?: string;
}

export function apiParentStudentsByStudentStudentIdGet$Json(http: HttpClient, rootUrl: string, params: ApiParentStudentsByStudentStudentIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliParentLinkedDto>>> {
  const rb = new RequestBuilder(rootUrl, apiParentStudentsByStudentStudentIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('studentId', params.studentId, {});
    rb.query('institutionId', params.institutionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliParentLinkedDto>>;
    })
  );
}

apiParentStudentsByStudentStudentIdGet$Json.PATH = '/api/parent-students/by-student/{studentId}';
